// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("images/inventory_background/middle_middle.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("images/inventory_background/middle_left.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("images/inventory_background/middle_right.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("images/inventory_background/top_middle.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("images/inventory_background/bottom_middle.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("images/inventory_background/top_left.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("images/inventory_background/top_right.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("images/inventory_background/bottom_left.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("images/inventory_background/bottom_right.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27><filter id=%27grayscale%27><feColorMatrix type=%27matrix%27 values=%270.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0%27/></filter></svg>#grayscale", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Start of JSX-specific CSS classes */
.add-listing-container {
  position: static !important;
  width: min-content;
  padding: 10px !important;
}

.centered {
  margin: 0 auto;
}

.inventories {
  display: inline-flex;
  margin-bottom: 30px;
  text-align: center;
}

.inventories .stash {
  margin-left: 30px;
}

.add-listing-form {
  margin-top: 30px;
}

.add-listing-button {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.add-listing-button a {
  text-decoration: none !important;
}

.listing-form {
  display: flex;
  margin-top: 1vw;
  margin-bottom: 1vw;
}

.listing-form input {
  margin-right: 5px;
}

.listing-form .button-container {
  display: flex;
  justify-content: space-between;
}

@media (max-width: 768px) {
  .add-listing-container {
    width: 100% !important;
  }

  .listing-form {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .listing-form input[type="text"] {
    width: 100%;
    box-sizing: border-box;
    /* Ensure padding and border are included in the element's total width */
  }

  .listing-form .button-container {
    margin-top: 10px;
    /* Optional: Add some margin for spacing */
  }

  .listing-form .rpgui-button {
    width: auto;
    flex: 1 1;
    /* Make buttons share available space equally */
    margin-right: 10px;
    /* Add margin between buttons */
  }

  .listing-form .rpgui-button:last-child {
    margin-right: 0;
    /* Remove margin on the last button */
  }

  .fixed-tooltip-content {
    font-size: 1.7vw !important;
    line-height: 2vw !important;
  }

  .fixed-tooltip-content span {
    font-size: 2vw !important;
  }
}

.item-dropdown select {
  width: 100% !important;
}

.item-dropdown .rpgui-dropdown-imp li {
  position: relative;
}

.item-dropdown .rpgui-dropdown-imp li:not(:first-child)::before {
  content: '';
  position: absolute;
  top: 0;
  left: -20px;
  right: 0;
  height: 1px;
  /* Adjust the height to match the desired border thickness */
  background-color: black;
  /* Adjust the color as needed */
}

.item-dropdown .rpgui-dropdown-imp.rpgui-dropdown-imp-header,
.item-dropdown .rpgui-dropdown-imp li {
  font-size: 0.7em !important;
}

.listing-item-form {
  padding-right: 20px;
}

.add-listing-form button {
  width: 100%;
}

.listing-item .fixed-tooltip {
  margin-top: 0px !important;
}

/* Mobile specific styles for the inventory-stash select */
.inventory-stash {
  display: none;
  flex-direction: column;
  margin-bottom: 30px;
}

.inventory-stash select {
  margin-bottom: 10px;
}

/* Responsive styles */
@media (max-width: 768px) {
  .inventories {
    display: none;
  }

  .inventory-stash {
    display: flex;
  }

  .add-listing-form {
    width: 100%;
    margin-top: 20px;
  }
}

@media (min-width: 769px) {
  .inventory-stash {
    display: none;
  }
}

/* End of JSX-specific CSS classes */

.osrpg-header h1 {
  font-size: 2rem !important;
}

@media (max-width: 768px) {

  /* Adjust font size for tablets and smaller screens */
  .osrpg-header h1 {
    font-size: 1.0rem !important;
  }
}

@media (max-width: 480px) {

  /* Adjust font size for mobile devices */
  .osrpg-header h1 {
    font-size: 0.8rem !important;
  }
}

@media (max-width: 768px) {

  /* Adjust font size for tablets and smaller screens */
  .twitch-btn {
    font-size: 0.9rem !important;
  }
}

@media (max-width: 480px) {

  /* Adjust font size for mobile devices */
  .twitch-btn {
    font-size: 0.7rem !important;
  }
}

.twitch-btn {
  background-color: #6441A4;
  color: white !important;
  padding: 10px 20px;
  font-size: 16px;
  text-decoration: none;
  border-radius: 4px;
  display: flex;
  align-items: center;
  width: 300px;
  height: 40px;
  margin: 0 auto;
}

.twitch-logo {
  width: 24px;
  margin-right: 10px;
}

.hide-on-mobile {
  display: none !important;
}

.osrpg-header .header-content {
  /*display: flex;*/
  align-items: center;
  justify-content: space-between;
  position: relative;
  flex-wrap: wrap;
}

.osrpg-header .header-content.mobile {
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.osrpg-header .user-info {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  margin-top: 10px;
  margin-bottom: 10px;
}

.premium-currency-content {
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}

/* Ensure navigation items are responsive */
.osrpg-nav .nav-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.osrpg-nav .nav-list li {
  margin: 0 10px;
}

@media (max-width: 768px) {
  .osrpg-header .header-content {
    flex-direction: column;
  }

  .osrpg-nav .nav-list {
    flex-direction: column;
  }

  .osrpg-nav .nav-list li {
    margin: 5px 0;
  }
}

.osrpg-nav select {
  width: 100%;
  text-align: center;
}

.osrpg-nav ul {
  list-style-type: none;
  display: flex;
  gap: 20px;
  padding: 0;
}

.osrpg-nav ul a {
  font-size: 1.1rem !important;
}

.osrpg-nav ul a.active {
  text-decoration: underline;
}

.osrpg-nav ul a:hover {
  text-decoration: underline !important;
}

@media (max-width: 768px) {

  /* Adjust font size for tablets and smaller screens */
  .osrpg-nav ul a {
    font-size: 0.7rem !important;
  }
}

@media (max-width: 480px) {

  /* Adjust font size for mobile devices */
  .osrpg-nav ul a {
    font-size: 0.5rem !important;
  }
}

.rpgui-content .rpgui-dropdown-imp-header {
  min-width: 200px;
}

.osrpg-header {
  margin-bottom: 30px;
}

body,
#container {
  background: #222;
  padding-top: 1vw;
  padding-bottom: 1vw;
}

.inner {
  background: #444;
  padding-left: 1vw !important;
  padding-right: 1vw !important;
  margin: 2vw 5vw;
}

.listing-table-container, .listings-table-container {
  position: static !important;
  width: 100%;
  padding: 0px !important;
}

.listings-table-container {
  min-height: 700px;
}

.listing-table-container th a, .listings-table-container th a {
  color: white !important;
}

.listing-table-container table, .listings-table-container table {
  border-collapse: collapse;
  width: calc(100% + 10px);
  margin: -5px;
}

.listing-table-container thead th, .listings-table-container thead th {
  padding-top: 10px;
  padding-bottom: 10px;
}

.listing-table-container tr,
.listing-table-container td,
.listing-table-container th, 
.listings-table-container tr,
.listings-table-container td,
.listings-table-container th {
  border: 4px solid #140C1C;
  text-align: center;
}

/* Striped rows */
tr:nth-child(even) {
  background-color: #ae7153;
}

/* Optional: Different color for the header */
th {
  background-color: #D27D2C;
  color: white;
}

td {
  color: white;
}

.inventory-row {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
}

.inventory-cell {
  width: 1.8vw;
  height: 1.8vw;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-content: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  color: white;
  text-shadow:
    -0.05vw -0.05vw 0 #000,
    0.05vw -0.05vw 0 #000,
    -0.05vw 0.05vw 0 #000,
    0.05vw 0.05vw 0 #000;
}

.inventory-cell:first-child {
  width: 1.9vw;
  padding-left: 0.052vw;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.inventory-cell:last-child {
  width: 1.9vw;
  padding-right: 0.052vw;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.inventory-row:first-child .inventory-cell {
  height: 1.9vw;
  padding-top: 0.052vw;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.inventory-row:last-child .inventory-cell {
  height: 1.9vw;
  padding-bottom: 0.052vw;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.inventory-row:first-child .inventory-cell:first-child {
  width: 1.9vw;
  height: 1.9vw;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.inventory-row:first-child .inventory-cell:last-child {
  width: 1.9vw;
  height: 1.9vw;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.inventory-row:last-child .inventory-cell:first-child {
  width: 1.9vw;
  height: 1.9vw;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.inventory-row:last-child .inventory-cell:last-child {
  width: 1.9vw;
  height: 1.9vw;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.inventory-row:only-child .inventory-cell {
  height: 2vw;
}

.inventory-row:only-child .inventory-cell:first-child {
  width: 1.9vw;
  height: 2vw;
  background-position: -29.85vw -14.87vw;
}

.inventory-row:only-child .inventory-cell:last-child {
  width: 1.9vw;
  height: 2vw;
  background-position: -33.8vw -14.87vw;
}

.inventory-row .inventory-cell:only-child {
  width: 2vw;
  background-position: -29.276vw -24.076vw;
}

.inventory-row:first-child .inventory-cell:only-child {
  width: 2vw;
  height: 1.9vw;
  background-position: -29.276vw -22.048vw;
}

.inventory-row:last-child .inventory-cell:only-child {
  width: 2vw;
  height: 1.9vw;
  background-position: -29.276vw -26vw;
}

.inventory-row:only-child .inventory-cell:only-child {
  width: 2vw;
  height: 2vw;
  background-position: -1.56vw -14.976vw;
}

.inventory-item {
  position: relative;
  width: 1.7vw;
  height: 1.7vw;
  background-repeat: no-repeat;
  transition: opacity 0.3s ease;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center, center center;
}

.inventory-item.active {
  background-color: #bbbbbb;
}

.inventory-item-sortable-placeholder {
  display: none;
}

.inventory-item.ui-sortable-helper,
.inventory-item.ui-draggable-dragging {
  opacity: .6;
}

.inventory-background {
  caret-color: transparent;
}

.item-image {
  width: 50px;
  height: 50px;
  background-size: cover;
  border: 0.052vw solid #351100;
  background-color: linear-gradient(145deg, #7A7875, #595652);
  border-radius: 0.52vw;
  float: right;
  margin-left: 5px;
  margin-top: 5px;
}

.fixed-tooltip {
  background-color: #595652;
  border: 0.42vw solid #ae6834;
  border-radius: 0.52vw;
  background-size: 100% 100% !important;
  background-position: center center !important;
  color: white;
  padding-left: 5px;
  padding-right: 5px;
  width: auto;
  margin-top: 30px;
  text-align: left;
}

.fixed-tooltip::before,
.fixed-tooltip::after {
  top: -0.1vw;
  left: -0.1vw;
  right: -0.1vw;
  bottom: -0.1vw;
  border-radius: 0.52vw;
}

.fixed-tooltip::before {
  border: 0.15vw solid black !important;
  top: -0.42vw;
  left: -0.42vw;
  right: -0.42vw;
  bottom: -0.42vw;
}

.fixed-tooltip::after {
  border: 0.15vw solid black;
}

.fixed-tooltip-content {
  font-size: 0.4vw;
  font-family: 'Press Start 2P', cursive;
  line-height: 0.7vw;
  color: white;
  text-shadow: -0.052vw 0 black, 0 0.052vw black, 0.052vw 0 black, 0 -0.052vw black;
}

.ui-tooltip {
  background-color: #595652;
  border: 0.42vw solid #ae6834;
  border-radius: 0.52vw;
  background-size: 100% 100% !important;
  background-position: center center !important;
  color: white;
  width: 18.2vw;
  padding: 0.26vw 3.33vw 0.26vw 0.52vw;
  z-index: 101;
  max-width: 20vw !important;
}

ui-tooltip::before,
.ui-tooltip::after {
  content: "";
  position: absolute;
  top: -0.1vw;
  left: -0.1vw;
  right: -0.1vw;
  bottom: -0.1vw;
  border-radius: 0.52vw;
}

.ui-tooltip::before {
  border: 0.15vw solid black !important;
  top: -0.42vw;
  left: -0.42vw;
  right: -0.42vw;
  bottom: -0.42vw;
}

.ui-tooltip::after {
  border: 0.15vw solid black;
}

.ui-tooltip-content {
  font-family: 'Press Start 2P', cursive;
  font-size: 0.5vw;
  line-height: 0.7vw;
  color: white;
  text-shadow: -0.052vw 0 black, 0 0.052vw black, 0.052vw 0 black, 0 -0.052vw black;
}

.listing-item {
  display: flex;
  width: 30vw;
  margin: 0 auto;
}

.listing-item .listing-item-form {
  flex: 0 0 25%;
}

.listing-item .listing-tooltip {}

.remove-listing {
  width: 100%;
}

.listing-item-image {
  width: 50px;
  height: 50px;
  background-size: cover;
  margin: 0 auto;
  background-color: linear-gradient(145deg, #7A7875, #595652);
  border-radius: 0.52vw;
}

.custom-amount::-webkit-outer-spin-button,
.custom-amount::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.spin-buttons {
  width: 1vw;
}

.spin-button {
  background: #7E4C34;
  color: white;
  font-size: 0.52vw;
}

.spin-button:hover {
  color: #C0C146;
  text-shadow: -0.052vw 0 black, 0 0.052vw black, 0.052vw 0 black, 0 -0.052vw black;
}

.confirmation-modal {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000 !important;
}

.confirmation-buttons {
  display: flex;
  justify-content: center;
}

.rcv-card-md .rcv-product-image-container, .rcv-card-md .rcv-product-image-container-custom {
  position: relative !important;
  overflow: hidden !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.image-border {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative !important;
  padding: 0 !important;
}

.euro-image {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  margin-top: -4px;
}

.rcv-product-description-custom {
  display: flex !important;
  align-items: center !important;
}

.small-image {
  width: 16px;
  height: 18px;
  margin-right: 10px;
  margin-top: -4px;
}

.notification .Toastify__toast-body {
  color: white;
}

.notification {}

.Toastify__toast-container {
  min-width: var(--toastify-toast-width) !important;
  width: auto !important;
  max-width: 25vw !important;
}

@media (max-width: 768px) {

  /* Adjust font size for tablets and smaller screens */
  .Toastify__toast-container {
    max-width: inherit !important;
  }

  td.pivoted {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }

  .osrpg-responsive-content {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow-wrap: anywhere;
  }

  .responsiveTable tr {
    display: grid !important;
    gap: 6px !important;
  }

  .confirmation-modal div, .confirmation-modal input {
    text-align: center;
  }
}

@media (max-width: 480px) {

  /* Adjust font size for mobile devices */
  .Toastify__toast-container {
    max-width: inherit !important;
  }

  .confirmation-modal .rpgui-button {
    width: 100%
  }

}

.osrpg-page-link {
  position: relative;
  display: block;
  padding: var(--pagination-padding-y, 0.375rem) var(--pagination-padding-x, 0.75rem);
  font-size: var(--pagination-font-size, 1rem);
  text-decoration: none;
  background-color: #D27D2C;
  border: 2px solid #140C1C;
  border-radius: var(--pagination-border-radius, 0.375rem);
  margin: 0 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.osrpg-page-link::after {
  content: '';
  position: absolute;
  top: -4px;
  left: -6px;
  right: -6px;
  bottom: -4px;
  padding: var(--pagination-padding-y, 0.375rem) var(--pagination-padding-x, 0.75rem);
  border: 2px solid #D27D2C;
  /* Second external border */
  border-radius: var(--pagination-border-radius, 0.375rem);
  margin: 0 var(--pagination-item-margin-x, 0.2rem);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  opacity: 0;
  /* Initially hidden */
}

.osrpg-page-link:hover::after {
  opacity: 1;
}

.osrpg-page-link:active {
  background-color: #854C30;
}

.pagination .active>.osrpg-page-link {
  text-decoration: underline;
}

.pagination .disabled>.osrpg-page-link {
  filter: grayscale(100%);
  filter: url(#greyscale);
  filter: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  filter: gray;
  color: #999;
}

.pagination {
  margin-top: 10px !important;
  padding-left: 0px !important;
}

.pagination li.page-item:first-of-type {
  margin-left: 0px !important;
}


.item-amount {
  position: absolute;
  bottom: 0;
  left: 0;
  color: white;
  padding: 0.1vw 0.3vw;
  font-size: 0.5vw;
  text-align: left;
  line-height: 0.5vw;
  white-space: pre;
}

input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: none;
  height: 3em;
  width: 3em;
  border-radius: 50em;
  background: url(https://pro.fontawesome.com/releases/v5.10.0/svgs/solid/times-circle.svg) no-repeat 50% 50%;
  background-size: contain;
  opacity: 0;
  pointer-events: none;
}

input[type="search"]:focus::-webkit-search-cancel-button {
  opacity: .3;
  pointer-events: all;
}

.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 300px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
  border-radius: 10px;
}

.close-button {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close-button:hover,
.close-button:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.modal-body input[type="number"]::-webkit-outer-spin-button,
.modal-body input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
}

.filter-option {
  display: flex;
  align-items: center;
}

.filter-option input {
  width: 30px !important;
  flex: 0 0 auto;
  margin-right: 10px;
  margin-left: 0;
}

.filter-option label {
  flex-grow: 1; /* Allow the label to take the remaining space */
  margin: 0; /* Ensure there is no margin that would cause the label to stack */
}

.filter-option p {
  margin: 0; /* Ensure the paragraph inside the label has no margin */
}

.current-filters {
  margin-bottom: 1vw;
}

.current-filters span {
  margin-left: 25px;
}

.filter-button {
  position: relative;
  padding: var(--pagination-padding-y, 0.375rem) var(--pagination-padding-x, 0.75rem);
  font-size: var(--pagination-font-size, 1rem);
  text-decoration: none;
  background-color: #D27D2C;
  border: 2px solid #140C1C;
  border-radius: var(--pagination-border-radius, 0.375rem);
  margin: 0 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.filter-button::after {
  content: '';
  position: absolute;
  top: -4px;
  left: -6px;
  right: -6px;
  bottom: -4px;
  padding: var(--pagination-padding-y, 0.375rem) var(--pagination-padding-x, 0.75rem);
  border: 2px solid #D27D2C;
  /* Second external border */
  border-radius: var(--pagination-border-radius, 0.375rem);
  margin: 0 var(--pagination-item-margin-x, 0.2rem);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  opacity: 0;
  /* Initially hidden */
}

.filter-button:hover::after {
  opacity: 1;
}

.filter-button:active {
  background-color: #854C30;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,wEAAwE;EAC1E;;EAEA;IACE,gBAAgB;IAChB,0CAA0C;EAC5C;;EAEA;IACE,WAAW;IACX,SAAO;IACP,+CAA+C;IAC/C,kBAAkB;IAClB,+BAA+B;EACjC;;EAEA;IACE,eAAe;IACf,qCAAqC;EACvC;;EAEA;IACE,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,QAAQ;EACR,WAAW;EACX,4DAA4D;EAC5D,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,oCAAoC;;AAEpC;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,qDAAqD;EACrD;IACE,4BAA4B;EAC9B;AACF;;AAEA;;EAEE,wCAAwC;EACxC;IACE,4BAA4B;EAC9B;AACF;;AAEA;;EAEE,qDAAqD;EACrD;IACE,4BAA4B;EAC9B;AACF;;AAEA;;EAEE,wCAAwC;EACxC;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;EAEE,qDAAqD;EACrD;IACE,4BAA4B;EAC9B;AACF;;AAEA;;EAEE,wCAAwC;EACxC;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;;;;;EAME,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;AAC3B;;AAEA,6CAA6C;AAC7C;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,4BAA4B;EAC5B,yDAAsE;EACtE,YAAY;EACZ;;;;wBAIsB;AACxB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,yDAAoE;AACtE;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,yDAAqE;AACvE;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,yDAAmE;AACrE;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,yDAAsE;AACxE;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yDAAiE;AACnE;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yDAAkE;AACpE;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yDAAoE;AACtE;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yDAAqE;AACvE;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,4BAA4B;EAE5B,6BAA6B;EAC7B,sBAAsB;EACtB,4BAA4B;EAC5B,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,2DAA2D;EAC3D,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,qBAAqB;EACrB,qCAAqC;EACrC,6CAA6C;EAC7C,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;EAClB,YAAY;EACZ,iFAAiF;AACnF;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,qBAAqB;EACrB,qCAAqC;EACrC,6CAA6C;EAC7C,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,iFAAiF;AACnF;;AAEA;EACE,aAAa;EACb,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA,gCAAgC;;AAEhC;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,cAAc;EACd,2DAA2D;EAC3D,qBAAqB;AACvB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iFAAiF;AACnF;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA,eAAe;;AAEf;EACE,iDAAiD;EACjD,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;;EAEE,qDAAqD;EACrD;IACE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;IACxB,kCAAkC;IAClC,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;;EAEE,wCAAwC;EACxC;IACE,6BAA6B;EAC/B;;EAEA;IACE;EACF;;AAEF;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mFAAmF;EACnF,4CAA4C;EAC5C,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,wDAAwD;EACxD,WAAW;EACX,qIAAqI;AACvI;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mFAAmF;EACnF,yBAAyB;EACzB,2BAA2B;EAC3B,wDAAwD;EACxD,iDAAiD;EACjD,qIAAqI;EACrI,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EAGE,uBAAuB;EACvB,uBAAuB;EACvB,+CAA2P;EAC3P,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;;AAGA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,2GAA2G;EAC3G,wBAAwB;EACxB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,cAAc;EACd,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY,EAAE,gDAAgD;EAC9D,SAAS,EAAE,kEAAkE;AAC/E;;AAEA;EACE,SAAS,EAAE,wDAAwD;AACrE;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mFAAmF;EACnF,4CAA4C;EAC5C,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,wDAAwD;EACxD,WAAW;EACX,qIAAqI;AACvI;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mFAAmF;EACnF,yBAAyB;EACzB,2BAA2B;EAC3B,wDAAwD;EACxD,iDAAiD;EACjD,qIAAqI;EACrI,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* Start of JSX-specific CSS classes */\n.add-listing-container {\n  position: static !important;\n  width: min-content;\n  padding: 10px !important;\n}\n\n.centered {\n  margin: 0 auto;\n}\n\n.inventories {\n  display: inline-flex;\n  margin-bottom: 30px;\n  text-align: center;\n}\n\n.inventories .stash {\n  margin-left: 30px;\n}\n\n.add-listing-form {\n  margin-top: 30px;\n}\n\n.add-listing-button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n.add-listing-button a {\n  text-decoration: none !important;\n}\n\n.listing-form {\n  display: flex;\n  margin-top: 1vw;\n  margin-bottom: 1vw;\n}\n\n.listing-form input {\n  margin-right: 5px;\n}\n\n.listing-form .button-container {\n  display: flex;\n  justify-content: space-between;\n}\n\n@media (max-width: 768px) {\n  .add-listing-container {\n    width: 100% !important;\n  }\n\n  .listing-form {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .listing-form input[type=\"text\"] {\n    width: 100%;\n    box-sizing: border-box;\n    /* Ensure padding and border are included in the element's total width */\n  }\n\n  .listing-form .button-container {\n    margin-top: 10px;\n    /* Optional: Add some margin for spacing */\n  }\n\n  .listing-form .rpgui-button {\n    width: auto;\n    flex: 1;\n    /* Make buttons share available space equally */\n    margin-right: 10px;\n    /* Add margin between buttons */\n  }\n\n  .listing-form .rpgui-button:last-child {\n    margin-right: 0;\n    /* Remove margin on the last button */\n  }\n\n  .fixed-tooltip-content {\n    font-size: 1.7vw !important;\n    line-height: 2vw !important;\n  }\n\n  .fixed-tooltip-content span {\n    font-size: 2vw !important;\n  }\n}\n\n.item-dropdown select {\n  width: 100% !important;\n}\n\n.item-dropdown .rpgui-dropdown-imp li {\n  position: relative;\n}\n\n.item-dropdown .rpgui-dropdown-imp li:not(:first-child)::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -20px;\n  right: 0;\n  height: 1px;\n  /* Adjust the height to match the desired border thickness */\n  background-color: black;\n  /* Adjust the color as needed */\n}\n\n.item-dropdown .rpgui-dropdown-imp.rpgui-dropdown-imp-header,\n.item-dropdown .rpgui-dropdown-imp li {\n  font-size: 0.7em !important;\n}\n\n.listing-item-form {\n  padding-right: 20px;\n}\n\n.add-listing-form button {\n  width: 100%;\n}\n\n.listing-item .fixed-tooltip {\n  margin-top: 0px !important;\n}\n\n/* Mobile specific styles for the inventory-stash select */\n.inventory-stash {\n  display: none;\n  flex-direction: column;\n  margin-bottom: 30px;\n}\n\n.inventory-stash select {\n  margin-bottom: 10px;\n}\n\n/* Responsive styles */\n@media (max-width: 768px) {\n  .inventories {\n    display: none;\n  }\n\n  .inventory-stash {\n    display: flex;\n  }\n\n  .add-listing-form {\n    width: 100%;\n    margin-top: 20px;\n  }\n}\n\n@media (min-width: 769px) {\n  .inventory-stash {\n    display: none;\n  }\n}\n\n/* End of JSX-specific CSS classes */\n\n.osrpg-header h1 {\n  font-size: 2rem !important;\n}\n\n@media (max-width: 768px) {\n\n  /* Adjust font size for tablets and smaller screens */\n  .osrpg-header h1 {\n    font-size: 1.0rem !important;\n  }\n}\n\n@media (max-width: 480px) {\n\n  /* Adjust font size for mobile devices */\n  .osrpg-header h1 {\n    font-size: 0.8rem !important;\n  }\n}\n\n@media (max-width: 768px) {\n\n  /* Adjust font size for tablets and smaller screens */\n  .twitch-btn {\n    font-size: 0.9rem !important;\n  }\n}\n\n@media (max-width: 480px) {\n\n  /* Adjust font size for mobile devices */\n  .twitch-btn {\n    font-size: 0.7rem !important;\n  }\n}\n\n.twitch-btn {\n  background-color: #6441A4;\n  color: white !important;\n  padding: 10px 20px;\n  font-size: 16px;\n  text-decoration: none;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  width: 300px;\n  height: 40px;\n  margin: 0 auto;\n}\n\n.twitch-logo {\n  width: 24px;\n  margin-right: 10px;\n}\n\n.hide-on-mobile {\n  display: none !important;\n}\n\n.osrpg-header .header-content {\n  /*display: flex;*/\n  align-items: center;\n  justify-content: space-between;\n  position: relative;\n  flex-wrap: wrap;\n}\n\n.osrpg-header .header-content.mobile {\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.osrpg-header .user-info {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  text-align: center;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.premium-currency-content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n}\n\n/* Ensure navigation items are responsive */\n.osrpg-nav .nav-list {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.osrpg-nav .nav-list li {\n  margin: 0 10px;\n}\n\n@media (max-width: 768px) {\n  .osrpg-header .header-content {\n    flex-direction: column;\n  }\n\n  .osrpg-nav .nav-list {\n    flex-direction: column;\n  }\n\n  .osrpg-nav .nav-list li {\n    margin: 5px 0;\n  }\n}\n\n.osrpg-nav select {\n  width: 100%;\n  text-align: center;\n}\n\n.osrpg-nav ul {\n  list-style-type: none;\n  display: flex;\n  gap: 20px;\n  padding: 0;\n}\n\n.osrpg-nav ul a {\n  font-size: 1.1rem !important;\n}\n\n.osrpg-nav ul a.active {\n  text-decoration: underline;\n}\n\n.osrpg-nav ul a:hover {\n  text-decoration: underline !important;\n}\n\n@media (max-width: 768px) {\n\n  /* Adjust font size for tablets and smaller screens */\n  .osrpg-nav ul a {\n    font-size: 0.7rem !important;\n  }\n}\n\n@media (max-width: 480px) {\n\n  /* Adjust font size for mobile devices */\n  .osrpg-nav ul a {\n    font-size: 0.5rem !important;\n  }\n}\n\n.rpgui-content .rpgui-dropdown-imp-header {\n  min-width: 200px;\n}\n\n.osrpg-header {\n  margin-bottom: 30px;\n}\n\nbody,\n#container {\n  background: #222;\n  padding-top: 1vw;\n  padding-bottom: 1vw;\n}\n\n.inner {\n  background: #444;\n  padding-left: 1vw !important;\n  padding-right: 1vw !important;\n  margin: 2vw 5vw;\n}\n\n.listing-table-container, .listings-table-container {\n  position: static !important;\n  width: 100%;\n  padding: 0px !important;\n}\n\n.listings-table-container {\n  min-height: 700px;\n}\n\n.listing-table-container th a, .listings-table-container th a {\n  color: white !important;\n}\n\n.listing-table-container table, .listings-table-container table {\n  border-collapse: collapse;\n  width: calc(100% + 10px);\n  margin: -5px;\n}\n\n.listing-table-container thead th, .listings-table-container thead th {\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n.listing-table-container tr,\n.listing-table-container td,\n.listing-table-container th, \n.listings-table-container tr,\n.listings-table-container td,\n.listings-table-container th {\n  border: 4px solid #140C1C;\n  text-align: center;\n}\n\n/* Striped rows */\ntr:nth-child(even) {\n  background-color: #ae7153;\n}\n\n/* Optional: Different color for the header */\nth {\n  background-color: #D27D2C;\n  color: white;\n}\n\ntd {\n  color: white;\n}\n\n.inventory-row {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: flex-start;\n  align-content: flex-start;\n}\n\n.inventory-cell {\n  width: 1.8vw;\n  height: 1.8vw;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  align-content: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-image: url('images/inventory_background/middle_middle.png');\n  color: white;\n  text-shadow:\n    -0.05vw -0.05vw 0 #000,\n    0.05vw -0.05vw 0 #000,\n    -0.05vw 0.05vw 0 #000,\n    0.05vw 0.05vw 0 #000;\n}\n\n.inventory-cell:first-child {\n  width: 1.9vw;\n  padding-left: 0.052vw;\n  background-image: url('images/inventory_background/middle_left.png');\n}\n\n.inventory-cell:last-child {\n  width: 1.9vw;\n  padding-right: 0.052vw;\n  background-image: url('images/inventory_background/middle_right.png');\n}\n\n.inventory-row:first-child .inventory-cell {\n  height: 1.9vw;\n  padding-top: 0.052vw;\n  background-image: url('images/inventory_background/top_middle.png');\n}\n\n.inventory-row:last-child .inventory-cell {\n  height: 1.9vw;\n  padding-bottom: 0.052vw;\n  background-image: url('images/inventory_background/bottom_middle.png');\n}\n\n.inventory-row:first-child .inventory-cell:first-child {\n  width: 1.9vw;\n  height: 1.9vw;\n  background-image: url('images/inventory_background/top_left.png');\n}\n\n.inventory-row:first-child .inventory-cell:last-child {\n  width: 1.9vw;\n  height: 1.9vw;\n  background-image: url('images/inventory_background/top_right.png');\n}\n\n.inventory-row:last-child .inventory-cell:first-child {\n  width: 1.9vw;\n  height: 1.9vw;\n  background-image: url('images/inventory_background/bottom_left.png');\n}\n\n.inventory-row:last-child .inventory-cell:last-child {\n  width: 1.9vw;\n  height: 1.9vw;\n  background-image: url('images/inventory_background/bottom_right.png');\n}\n\n.inventory-row:only-child .inventory-cell {\n  height: 2vw;\n}\n\n.inventory-row:only-child .inventory-cell:first-child {\n  width: 1.9vw;\n  height: 2vw;\n  background-position: -29.85vw -14.87vw;\n}\n\n.inventory-row:only-child .inventory-cell:last-child {\n  width: 1.9vw;\n  height: 2vw;\n  background-position: -33.8vw -14.87vw;\n}\n\n.inventory-row .inventory-cell:only-child {\n  width: 2vw;\n  background-position: -29.276vw -24.076vw;\n}\n\n.inventory-row:first-child .inventory-cell:only-child {\n  width: 2vw;\n  height: 1.9vw;\n  background-position: -29.276vw -22.048vw;\n}\n\n.inventory-row:last-child .inventory-cell:only-child {\n  width: 2vw;\n  height: 1.9vw;\n  background-position: -29.276vw -26vw;\n}\n\n.inventory-row:only-child .inventory-cell:only-child {\n  width: 2vw;\n  height: 2vw;\n  background-position: -1.56vw -14.976vw;\n}\n\n.inventory-item {\n  position: relative;\n  width: 1.7vw;\n  height: 1.7vw;\n  background-repeat: no-repeat;\n  -webkit-transition: opacity 0.3s ease;\n  transition: opacity 0.3s ease;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center center, center center;\n}\n\n.inventory-item.active {\n  background-color: #bbbbbb;\n}\n\n.inventory-item-sortable-placeholder {\n  display: none;\n}\n\n.inventory-item.ui-sortable-helper,\n.inventory-item.ui-draggable-dragging {\n  opacity: .6;\n}\n\n.inventory-background {\n  caret-color: transparent;\n}\n\n.item-image {\n  width: 50px;\n  height: 50px;\n  background-size: cover;\n  border: 0.052vw solid #351100;\n  background-color: linear-gradient(145deg, #7A7875, #595652);\n  border-radius: 0.52vw;\n  float: right;\n  margin-left: 5px;\n  margin-top: 5px;\n}\n\n.fixed-tooltip {\n  background-color: #595652;\n  border: 0.42vw solid #ae6834;\n  border-radius: 0.52vw;\n  background-size: 100% 100% !important;\n  background-position: center center !important;\n  color: white;\n  padding-left: 5px;\n  padding-right: 5px;\n  width: auto;\n  margin-top: 30px;\n  text-align: left;\n}\n\n.fixed-tooltip::before,\n.fixed-tooltip::after {\n  top: -0.1vw;\n  left: -0.1vw;\n  right: -0.1vw;\n  bottom: -0.1vw;\n  border-radius: 0.52vw;\n}\n\n.fixed-tooltip::before {\n  border: 0.15vw solid black !important;\n  top: -0.42vw;\n  left: -0.42vw;\n  right: -0.42vw;\n  bottom: -0.42vw;\n}\n\n.fixed-tooltip::after {\n  border: 0.15vw solid black;\n}\n\n.fixed-tooltip-content {\n  font-size: 0.4vw;\n  font-family: 'Press Start 2P', cursive;\n  line-height: 0.7vw;\n  color: white;\n  text-shadow: -0.052vw 0 black, 0 0.052vw black, 0.052vw 0 black, 0 -0.052vw black;\n}\n\n.ui-tooltip {\n  background-color: #595652;\n  border: 0.42vw solid #ae6834;\n  border-radius: 0.52vw;\n  background-size: 100% 100% !important;\n  background-position: center center !important;\n  color: white;\n  width: 18.2vw;\n  padding: 0.26vw 3.33vw 0.26vw 0.52vw;\n  z-index: 101;\n  max-width: 20vw !important;\n}\n\nui-tooltip::before,\n.ui-tooltip::after {\n  content: \"\";\n  position: absolute;\n  top: -0.1vw;\n  left: -0.1vw;\n  right: -0.1vw;\n  bottom: -0.1vw;\n  border-radius: 0.52vw;\n}\n\n.ui-tooltip::before {\n  border: 0.15vw solid black !important;\n  top: -0.42vw;\n  left: -0.42vw;\n  right: -0.42vw;\n  bottom: -0.42vw;\n}\n\n.ui-tooltip::after {\n  border: 0.15vw solid black;\n}\n\n.ui-tooltip-content {\n  font-family: 'Press Start 2P', cursive;\n  font-size: 0.5vw;\n  line-height: 0.7vw;\n  color: white;\n  text-shadow: -0.052vw 0 black, 0 0.052vw black, 0.052vw 0 black, 0 -0.052vw black;\n}\n\n.listing-item {\n  display: flex;\n  width: 30vw;\n  margin: 0 auto;\n}\n\n.listing-item .listing-item-form {\n  flex: 0 0 25%;\n}\n\n.listing-item .listing-tooltip {}\n\n.remove-listing {\n  width: 100%;\n}\n\n.listing-item-image {\n  width: 50px;\n  height: 50px;\n  background-size: cover;\n  margin: 0 auto;\n  background-color: linear-gradient(145deg, #7A7875, #595652);\n  border-radius: 0.52vw;\n}\n\n.custom-amount::-webkit-outer-spin-button,\n.custom-amount::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.spin-buttons {\n  width: 1vw;\n}\n\n.spin-button {\n  background: #7E4C34;\n  color: white;\n  font-size: 0.52vw;\n}\n\n.spin-button:hover {\n  color: #C0C146;\n  text-shadow: -0.052vw 0 black, 0 0.052vw black, 0.052vw 0 black, 0 -0.052vw black;\n}\n\n.confirmation-modal {\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 1000 !important;\n}\n\n.confirmation-buttons {\n  display: flex;\n  justify-content: center;\n}\n\n.rcv-card-md .rcv-product-image-container, .rcv-card-md .rcv-product-image-container-custom {\n  position: relative !important;\n  overflow: hidden !important;\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n}\n\n.image-border {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative !important;\n  padding: 0 !important;\n}\n\n.euro-image {\n  width: 20px;\n  height: 20px;\n  margin-right: 10px;\n  margin-top: -4px;\n}\n\n.rcv-product-description-custom {\n  display: flex !important;\n  align-items: center !important;\n}\n\n.small-image {\n  width: 16px;\n  height: 18px;\n  margin-right: 10px;\n  margin-top: -4px;\n}\n\n.notification .Toastify__toast-body {\n  color: white;\n}\n\n.notification {}\n\n.Toastify__toast-container {\n  min-width: var(--toastify-toast-width) !important;\n  width: auto !important;\n  max-width: 25vw !important;\n}\n\n@media (max-width: 768px) {\n\n  /* Adjust font size for tablets and smaller screens */\n  .Toastify__toast-container {\n    max-width: inherit !important;\n  }\n\n  td.pivoted {\n    display: flex !important;\n    justify-content: center !important;\n    align-items: center !important;\n  }\n\n  .osrpg-responsive-content {\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow-wrap: anywhere;\n  }\n\n  .responsiveTable tr {\n    display: grid !important;\n    gap: 6px !important;\n  }\n\n  .confirmation-modal div, .confirmation-modal input {\n    text-align: center;\n  }\n}\n\n@media (max-width: 480px) {\n\n  /* Adjust font size for mobile devices */\n  .Toastify__toast-container {\n    max-width: inherit !important;\n  }\n\n  .confirmation-modal .rpgui-button {\n    width: 100%\n  }\n\n}\n\n.osrpg-page-link {\n  position: relative;\n  display: block;\n  padding: var(--pagination-padding-y, 0.375rem) var(--pagination-padding-x, 0.75rem);\n  font-size: var(--pagination-font-size, 1rem);\n  text-decoration: none;\n  background-color: #D27D2C;\n  border: 2px solid #140C1C;\n  border-radius: var(--pagination-border-radius, 0.375rem);\n  margin: 0 0;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.osrpg-page-link::after {\n  content: '';\n  position: absolute;\n  top: -4px;\n  left: -6px;\n  right: -6px;\n  bottom: -4px;\n  padding: var(--pagination-padding-y, 0.375rem) var(--pagination-padding-x, 0.75rem);\n  border: 2px solid #D27D2C;\n  /* Second external border */\n  border-radius: var(--pagination-border-radius, 0.375rem);\n  margin: 0 var(--pagination-item-margin-x, 0.2rem);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  opacity: 0;\n  /* Initially hidden */\n}\n\n.osrpg-page-link:hover::after {\n  opacity: 1;\n}\n\n.osrpg-page-link:active {\n  background-color: #854C30;\n}\n\n.pagination .active>.osrpg-page-link {\n  text-decoration: underline;\n}\n\n.pagination .disabled>.osrpg-page-link {\n  -webkit-filter: grayscale(1);\n  -webkit-filter: grayscale(100%);\n  filter: grayscale(100%);\n  filter: url(#greyscale);\n  filter: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg'><filter id='grayscale'><feColorMatrix type='matrix' values='0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0'/></filter></svg>#grayscale\");\n  filter: gray;\n  color: #999;\n}\n\n.pagination {\n  margin-top: 10px !important;\n  padding-left: 0px !important;\n}\n\n.pagination li.page-item:first-of-type {\n  margin-left: 0px !important;\n}\n\n\n.item-amount {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  color: white;\n  padding: 0.1vw 0.3vw;\n  font-size: 0.5vw;\n  text-align: left;\n  line-height: 0.5vw;\n  white-space: pre;\n}\n\ninput[type=\"search\"]::-webkit-search-cancel-button {\n  -webkit-appearance: none;\n  height: 3em;\n  width: 3em;\n  border-radius: 50em;\n  background: url(https://pro.fontawesome.com/releases/v5.10.0/svgs/solid/times-circle.svg) no-repeat 50% 50%;\n  background-size: contain;\n  opacity: 0;\n  pointer-events: none;\n}\n\ninput[type=\"search\"]:focus::-webkit-search-cancel-button {\n  opacity: .3;\n  pointer-events: all;\n}\n\n.modal {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  z-index: 1000;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background-color: rgb(0, 0, 0);\n  background-color: rgba(0, 0, 0, 0.4);\n}\n\n.modal-content {\n  background-color: #fefefe;\n  margin: auto;\n  padding: 20px;\n  border: 1px solid #888;\n  width: 300px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);\n  border-radius: 10px;\n}\n\n.close-button {\n  color: #aaa;\n  float: right;\n  font-size: 28px;\n  font-weight: bold;\n}\n\n.close-button:hover,\n.close-button:focus {\n  color: black;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.modal-body input[type=\"number\"]::-webkit-outer-spin-button,\n.modal-body input[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.filter-option {\n  display: flex;\n  align-items: center;\n}\n\n.filter-option input {\n  width: 30px !important;\n  flex: 0 0 auto;\n  margin-right: 10px;\n  margin-left: 0;\n}\n\n.filter-option label {\n  flex-grow: 1; /* Allow the label to take the remaining space */\n  margin: 0; /* Ensure there is no margin that would cause the label to stack */\n}\n\n.filter-option p {\n  margin: 0; /* Ensure the paragraph inside the label has no margin */\n}\n\n.current-filters {\n  margin-bottom: 1vw;\n}\n\n.current-filters span {\n  margin-left: 25px;\n}\n\n.filter-button {\n  position: relative;\n  padding: var(--pagination-padding-y, 0.375rem) var(--pagination-padding-x, 0.75rem);\n  font-size: var(--pagination-font-size, 1rem);\n  text-decoration: none;\n  background-color: #D27D2C;\n  border: 2px solid #140C1C;\n  border-radius: var(--pagination-border-radius, 0.375rem);\n  margin: 0 0;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.filter-button::after {\n  content: '';\n  position: absolute;\n  top: -4px;\n  left: -6px;\n  right: -6px;\n  bottom: -4px;\n  padding: var(--pagination-padding-y, 0.375rem) var(--pagination-padding-x, 0.75rem);\n  border: 2px solid #D27D2C;\n  /* Second external border */\n  border-radius: var(--pagination-border-radius, 0.375rem);\n  margin: 0 var(--pagination-item-margin-x, 0.2rem);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  opacity: 0;\n  /* Initially hidden */\n}\n\n.filter-button:hover::after {\n  opacity: 1;\n}\n\n.filter-button:active {\n  background-color: #854C30;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
